import { MergePatientsModalConfirmation } from '@/components/MergePatients/MergePatientsModalConfirmation';
import type { PatientDetails } from '@/components/MergePatients/MergePatientsModalContent';
import { emptyPatientDetails, MergePatientsModalContent } from '@/components/MergePatients/MergePatientsModalContent';
import { MergePatientsModalHeader } from '@/components/MergePatients/MergePatientsModalHeader';
import { Modal, Paper, styled } from '@mui/material';
import { useState } from 'react';

type MergePatientsModalProps = { open: boolean; setOpen: (open: boolean) => void };

const StyledModal = styled(Modal)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'scroll',
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
  width: 1000,
  outline: 'none',
  padding: theme.spacing(10),
}));

export const MergePatientsModal = ({ open, setOpen }: MergePatientsModalProps) => {
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [primaryPatientDetails, setPrimaryPatientDetails] = useState<PatientDetails>(emptyPatientDetails);
  const [secondaryPatientDetails, setSecondaryPatientDetails] = useState<PatientDetails>(emptyPatientDetails);

  const onClose = () => {
    setOpen(false);
    setShowConfirmation(false);
    setPrimaryPatientDetails(emptyPatientDetails);
    setSecondaryPatientDetails(emptyPatientDetails);
  };

  return (
    <StyledModal open={open} onClose={onClose}>
      <StyledPaper>
        <MergePatientsModalHeader />
        {showConfirmation ? (
          <MergePatientsModalConfirmation
            onClose={onClose}
            primaryPatientDetails={primaryPatientDetails}
            secondaryPatientDetails={secondaryPatientDetails}
          />
        ) : (
          <MergePatientsModalContent
            onClose={onClose}
            setShowConfirmation={setShowConfirmation}
            primaryPatientDetails={primaryPatientDetails}
            setPrimaryPatientDetails={setPrimaryPatientDetails}
            secondaryPatientDetails={secondaryPatientDetails}
            setSecondaryPatientDetails={setSecondaryPatientDetails}
          />
        )}
      </StyledPaper>
    </StyledModal>
  );
};
